import React from 'react';
import {DateTimeFormat} from 'components/UI/DateTime';
import {getPrice} from 'lib/convert';

class OrderBusinessBox extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  // deprecated
  getPrice(value) {
    String.prototype.splice = function(idx, rem, str) {
      return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
    };
    let result = value;
    if(String(result).length < 3) {
      return result
    } else {
      for (let j = Number(String(result).length); j > 0;) {
        j = j - 3;
        if(j > 0) {
          result = String(result).splice(j, 0, ",");
        }
      }
      return result
    }
  }

  render() {
    console.log(this.props)
    let {order} = this.props
    return (
      <tbody>
        <tr>
          <td>{this.props.index}</td>
          <td>
            <p>Người mua hàng: {order.customerName}</p>
            <p>Số điện thoại: {order.customerPhone}</p>
          </td>
          <td>
            { this.props.status && this.props.status === 1 && (<p className='status'>Đang tiếp nhận</p>)}
            { this.props.status && this.props.status === 2 && (<p className='status danger'>Đã hủy</p>)}
            { this.props.status && this.props.status === 3 && (<p className='status success'>Đã hoàn thành</p>)}
          </td>
          <td>
            <DateTimeFormat value={order.createdAt}/>
          </td>
          <td>
            <span>{getPrice(order.amount)}</span>
          </td>
        </tr>

      </tbody>


    );
  }
}

export default OrderBusinessBox;



// WEBPACK FOOTER //
// ./components/fair/fair-order/OrderBusinessBox.jsx